import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
// import Stepper from './stepper';
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

export const Step1 = ({
  nextStep,
  handleChange,
  handleCustomZipCode,
  addToState,
  values,
}) => {
  const { t } = useTranslation("global");
  const {
    register,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // validation messages for radio fields
  const [RequiredFormTypeMessage, setRequiredFormTypeMessage] = useState(false);
  const navigate = useNavigate();

  const Continue = (e) => {
    // // console.log('Submit', e)
    e.preventDefault();

    // // console.log('values.formType', values.formType)
    // validate radio field
    if (!values.formType) {
      setRequiredFormTypeMessage(t("requiredFieldMessage"));
    } else {
      setRequiredFormTypeMessage(false);
    }

    // validate fields
    trigger().then((r) => {
      // if fields completed as required, move to next step
      // // console.log('Move on?', r)
      if (r === true && values.formType) {
        handleCustomZipCode();
        nextStep();
        navigate(
          `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=details`
        );
      }
    });

    //TODO: MAKE API CALL
  };

  const handleKeyEnter = (e) => {
    // // console.log('Key up', e.keyCode)
    // // console.log('Key up', e.target.value)
    addToState("zipCode", e.target.value);
    if (e.keyCode === 13) {
      trigger("zipCode").then((r) => {
        // if fields completed as required, move to next step
        // // console.log('handleKeyEnter Move on?', r)
        if (r === true && values.formType) {
          handleCustomZipCode();
          nextStep();
          // NAVIGATE TO NEXT PAGE
          navigate(
            `/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=details`
          );

          // axios.post('<API URL GOES HERE>',values.zipCode).then((response) => {
          //   // API call is successfull
          //   //
          // }).catch((error) => {
          //   // API CALL FAILED
          // })
        }
      });
    }
  };

  const IsFormType = (str) => {
    if (values.formType === str) {
      return true;
    }
  };
  // console.log(values);

  return (
    <Container style={{ marginTop: "2%" }}>
      <Row>
        <Col lg={3}></Col>
        <Col lg={7}>
          <div className="page-texts">
            <p className="title">{t("step1.page.title")}</p>
            <p className="subtitle">{t("step1.page.subtitle")}</p>
          </div>
        </Col>
      </Row>

      <Row style={{ marginTop: "1rem" }}>
        <Col lg={3}>{/* <Stepper step="1" t={t}></Stepper> */}</Col>
        <Col lg={7}>
          <div className="form-texts">
            <p className="title">{t("step1.form.title")}</p>
            <p className="subtitle">{t("step1.form.subtitle")}</p>
          </div>

          <Form style={{ textAlign: "left" }} onSubmit={handleSubmit(Continue)}>
            <div
              className="div-step1-inputs commercial-or-personal"
              key="inline-radio"
              value={values.formType}
              onChange={handleChange("formType")}
              style={{ width: "60%" }}
            >
              <Form.Check
                inline
                type="radio"
                name="1"
                label={t("step1.form.formType.labelPersonal")}
                value="Personal"
                defaultChecked={IsFormType("personal")}
                id="radio-formtype-personal"
              />
              <Form.Check
                inline
                type="radio"
                name="1"
                label={t("step1.form.formType.labelCommercial")}
                value="Commercial"
                defaultChecked={IsFormType("commercial")}
                id="radio-formtype-commercial"
              />
              <p className="require-field-message">{RequiredFormTypeMessage}</p>
            </div>
            <br />

            <Form.Group className="div-step1-inputs" style={{ width: "60%" }}>
              <Form.Label>{t("step1.form.zipCode.label")}</Form.Label>
              {/* <Form.Control {...register("zipCode", { required: true })}  maxLength="5"  onChange={handleChange('zipCode')} /> */}
              <Form.Control
                {...register("zipCode", {
                  required: true,
                  pattern: /^[0-9]{5}/i,
                })}
                type="number"
                maxLength="5"
                name="zipCode"
                onKeyUp={handleKeyEnter}
              />
              {errors.zipCode && (
                <p className="require-field-message">{t("requiredValidZip")}</p>
              )}
            </Form.Group>
            <br />

            <Row>
              <Col lg={5}>
                <Link
                  to={`/calculator/?lan=${values.language}&type=${values.formType}&zip=${values.zipCode}&step=details`}
                >
                  <Button variant="success" onClick={Continue}>
                    {t("step1.form.nextButton")}
                  </Button>
                </Link>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Step1;
